export const MILLISECONDS_IN_SECOND = 1000;
export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE;

export const TASK_SLA_CRITICAL_THRESHOLD_SECONDS = 30;
export const TASK_SLA_URGENT_THRESHOLD_SECONDS = 2 * SECONDS_IN_MINUTE;
export const TASK_SLA_ALERT_THRESHOLD_SECONDS = 5 * SECONDS_IN_MINUTE;
export const TASK_SLA_NOTICE_THRESHOLD_SECONDS = 10 * SECONDS_IN_MINUTE;

export const TASK_SLA_PULSE_LEVELS = [
  { threshold: TASK_SLA_CRITICAL_THRESHOLD_SECONDS, level: 'critical' },
  { threshold: TASK_SLA_URGENT_THRESHOLD_SECONDS, level: 'urgent' },
  { threshold: TASK_SLA_ALERT_THRESHOLD_SECONDS, level: 'alert' },
  { threshold: TASK_SLA_NOTICE_THRESHOLD_SECONDS, level: 'notice' },
] as const;
